// Gửi các điểm đo trong RAM (src/core/perf.ts) lên bảng do_thoi_gian.
// Chạy ngầm, lỗi thì im — không bao giờ chặn UI vì việc đo lường (§6.2).
import { layDiemDoGanNhat, type DiemDo } from "../core/perf";
import { supabase } from "./supabaseClient";

let da_gui_toi = 0; // index trong mảng RAM đã gửi xong, tránh gửi trùng

export async function guiDiemDoLenServer(phien_ban_app: string): Promise<void> {
  try {
    const tat_ca = layDiemDoGanNhat();
    const chua_gui = tat_ca.slice(da_gui_toi);
    if (chua_gui.length === 0) return;

    // app_user_id/email do trigger tg_do_thoi_gian_bien_dien điền từ phiên đăng nhập,
    // không gửi lên từ client (tránh 1 người tự nhận là người khác trong số liệu đo lường).
    const dong: Record<string, unknown>[] = chua_gui.map((d: DiemDo) => ({
      man_hinh: d.man_hinh,
      buoc: d.buoc,
      ms: d.ms,
      so_dong: d.so_dong ?? null,
      byte: d.byte ?? null,
      cache_hit: d.cache_hit ?? null,
      phien_ban_app,
    }));

    const { error } = await supabase.from("do_thoi_gian").insert(dong);
    if (!error) da_gui_toi = tat_ca.length;
  } catch {
    // im lặng — đo lường không được làm vỡ luồng chính
  }
}
